import {Mapper} from '../../../../../core/abstracts/mapper.abstract';
import {VehicleSearchResponse} from '../models/vehicle-search-response.model';
import {VehicleSearch} from '../models/vehicle-search.model';
import {Injectable} from '@angular/core';
import {toDateTimeHelper} from '../../../../../core/helpers/to-datetime.helper';

@Injectable({providedIn: 'root'})
export class VehicleSearchResponseMapper extends Mapper<VehicleSearchResponse, VehicleSearch> {

  public override map(source: VehicleSearchResponse): VehicleSearch {
    return new VehicleSearch(
      source.id,
      source.brand,
      source.model,
      source.category,
      source.vin,
      source.registrationPlate,
      source.factoryNumber,
      source.storageName,
      source.ownerName,
      source.returningPerson,
      toDateTimeHelper(source.returnDate),
      toDateTimeHelper(source.releaseDate),
      source.receiver,
      source.keyNumber,
      source.documentNumber,
      source.archiveNumber
    );
  }
}
